import { Skeleton, styled } from '@mui/material'

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.surface[900],
}))
